module.exports = __webpack_public_path__ + "static/media/numeric.6be1de32.svg";